import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";

// Main site components
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import AppsShowcase from "./components/AppsShowcase";
import ServicesSection from "./components/ServicesSection";
import WebsiteBuilderShowcase from "./components/WebsiteBuilderShowcase";
import AboutSection from "./components/AboutSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

// Admin components
import AdminLogin from "./components/admin/AdminLogin";
import AdminDashboard from "./components/admin/AdminDashboard";
import AuthCallback from "./components/admin/AuthCallback";
import ProtectedRoute from "./components/admin/ProtectedRoute";
import WebsiteEditor from "./components/admin/WebsiteEditor";
import WebsitePreview from "./components/admin/WebsitePreview";
import AppHub from "./components/admin/AppHub";
import AppStudio from "./components/admin/AppStudio";
import ContactInbox from "./components/admin/ContactInbox";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-[#1a1c1b]">
      <Header />
      <main>
        <HeroSection />
        <AppsShowcase />
        <WebsiteBuilderShowcase />
        <ServicesSection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

// Router component that handles auth callback detection
const AppRouter = () => {
  const location = useLocation();

  // Check URL fragment for session_id - must be synchronous (before useEffect)
  // REMINDER: This handles the auth callback before protected routes run
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      {/* Main Website */}
      <Route path="/" element={<HomePage />} />
      
      {/* Admin Routes */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/callback" element={<AuthCallback />} />
      <Route
        path="/admin/dashboard"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/editor/:projectId"
        element={
          <ProtectedRoute>
            <WebsiteEditor />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/preview/:projectId"
        element={
          <ProtectedRoute>
            <WebsitePreview />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/hub"
        element={
          <ProtectedRoute>
            <AppHub />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/studio"
        element={
          <ProtectedRoute>
            <AppStudio />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/inbox"
        element={
          <ProtectedRoute>
            <ContactInbox />
          </ProtectedRoute>
        }
      />
      
      {/* Redirect /admin to dashboard */}
      <Route path="/admin" element={
        <ProtectedRoute>
          <AdminDashboard />
        </ProtectedRoute>
      } />
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <div className="App">
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </div>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
